import { HeadCell } from 'app/agriculture/components/Table/SortableTableHead';
import { ComponentProps } from 'react';
import { Button } from 'app/agriculture/components/Button/Button';
import './SortableTable.scss';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import { SortableTableHeadSkeleton } from 'app/agriculture/components/Table/SortableTableHeadSkeleton';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Skeleton } from '@mui/material';

interface SortableTableSkeletonProps {
    headCells: (HeadCell<Record<string, string>> & { width?: number })[];
    button?: () => ComponentProps<typeof Button>;
    rows?: number;
}

export function SortableTableSkeleton({ headCells, button, rows = 5 }: SortableTableSkeletonProps) {
    return (
        <TableContainer className="SortableTable">
            <Table aria-labelledby="tableTitle" size="medium">
                <SortableTableHeadSkeleton headCells={headCells} hasButton={!!button} />
                <TableBody>
                    {Array.from({ length: rows }, () => 'row').map((row, i) => (
                        // All the rows are identical so ordering shouldn't matter
                        // eslint-disable-next-line react/no-array-index-key
                        <TableRow key={`${row}-${i}`}>
                            {headCells.map(({ key, width }) => (
                                <TableCell key={key}>
                                    <Skeleton variant="text" width={width} />
                                </TableCell>
                            ))}
                            {!!button && (
                                <TableCell align="right">
                                    <Button {...button()} disabled />
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
